import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  align-items: center;
  min-height: 100vh;
  display: flex;
  background-color: #f0f0f0;
  flex-direction: column;

  div {
    max-width: 1100px;
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
  }

  img {
    width: 50%;
    max-width: 300px;
    margin-bottom: 25px;
  }

  h1 {
    width: 100%;
    text-align: left;
    font-size: 40px;
  }

  h2 {
    width: 100%;
    text-align: left;
    font-size: 30px;
  }

  h3 {
    width: 100%;
    text-align: left;
    font-size: 26px;
  }

  h4 {
    width: 100%;
    text-align: left;
    font-size: 20px;
  }

  h5 {
    width: 100%;
    text-align: left;
    font-size: 15px;
    color: #555;
  }

  span {
    width: 100%;
    text-align: left;
  }

  strong {
    color: #000;
    font-size: 18px;
    text-align: center;
  }
`;

export const Images = styled.div`
  display: flex;
  max-width: 1100px;
  width: 100%;
  margin-top: 15px;
  overflow-x: auto;
  flex-direction: row;
  &::-webkit-scrollbar {
    width: 8px; /* Largura da barra de rolagem vertical */
    height: 8px; /* Altura da barra de rolagem horizontal */
    background-color: rgba(0, 0, 0, 0.1);
  }

  &::-webkit-scrollbar-track {
    background: 0, 0, 0, 0.25; /* Fundo transparente da trilha da barra */
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(
      0,
      0,
      0,
      0.2
    ); /* Cor do "puxador" da barra (um cinza semitransparente) */
    border-radius: 4px; /* Bordas arredondadas */
  }

  /* Opcional: Efeito de hover */
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.4);
  }
  h2 {
    color: #000;
    font-size: 18px;
    width: 100%;
    text-align: left;
    margin: 10px 0;
    font-weight: bold;
  }
`;

export const Image = styled.div`
  display: flex;
  flex-direction: column !important;
  min-width: 200px;
  max-width: 200px;
  min-height: 150px;
  align-items: center;
  margin: 10px;

  img {
    object-fit: contain;
    width: 200px;
    max-height: 180px;
  }
`;

export const RiskItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 15px;
  position: relative;
  margin-bottom: 15px;
  font-size: 12px;

  strong {
    font-size: 12px;
  }
  p {
    font-size: 12px;
  }

  .risk-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    font-size: 12px;
    p {
      margin-bottom: 5px;
    }
  }

  .risk-actions {
    display: flex;
    justify-content: flex-end;

    @media (min-width: 900px) {
      position: absolute;
      right: 15px;
      top: 15px;
    }

    button {
      margin-left: 10px;
    }
  }
`;

export const Risks = styled.div`
  display: flex;
  max-width: 1100px;
  width: 100%;
  flex-direction: column;

  h2 {
    color: #000;
    font-size: 18px;
    width: 100%;
    text-align: left;
    margin: 10px 0;
    font-weight: bold;
  }
`;

export const Risk = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 196px;
  max-width: 196px;
  min-height: 150px;
  align-items: center;
  margin: 10px;

  h2 {
    color: #444;
    font-size: 15px;
    width: 100%;
    text-align: center;
    margin: 10px 0;
    font-weight: bold;
  }

  p {
    font-size: 12px;
    margin-top: 5px;
    width: 100%;
  }

  input {
    margin: 5px 0;
    padding: 4px;
    width: 100%;
  }
`;
